import stickybits from 'stickybits';

export function initServiceComparisonComponent() {
   stickybits(".mobile-sticky-header");
}